import ModalProvider from "@repo/components/src/globalProviders/modal";
import { BasicModal } from "@repo/components/src/shared/modal";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import dayjs from "dayjs";
import { ChevronLeft, ChevronRight } from "lucide-react-native";
import { useRef, useState } from "react";
import DateTimePicker, {
  useDefaultClassNames,
} from "react-native-ui-datepicker";
import { Icon } from "../../ui/icon";
import { ShowDatePickerOptions } from "./types";

function DatePickerContent(
  props: ShowDatePickerOptions & { hide: () => void },
) {
  const { hide, date, onConfirm, onBlur, minDate } = props;
  const initial = date || dayjs().toDate();
  const ref = useRef<Date>(initial);
  const [selected, setSelected] = useState<Date>(initial);
  const defaultClassNames = useDefaultClassNames();

  const confirm = () => {
    onConfirm(ref.current);
    onBlur();
    hide();
  };

  return (
    <BasicModal
      title="Ingrese una fecha"
      hide={hide}
      cancelButton={{
        text: "Salir",
        props: { size: "md", className: "flex-1", onPress: hide },
      }}
      footer={
        <Button
          variant="solid"
          className="flex-1"
          action="brand"
          onPress={confirm}
          size="md"
        >
          <ButtonText>Elegir</ButtonText>
        </Button>
      }
    >
      <DateTimePicker
        mode="single"
        date={selected}
        minDate={minDate}
        onChange={(dates) => {
          if (!dates.date) return;
          const picked =
            dates.date instanceof Date
              ? new Date(dates.date)
              : dates.date instanceof dayjs.Dayjs
                ? dates.date.toDate()
                : new Date(dates.date);
          ref.current = picked;
          setSelected(picked);
        }}
        firstDayOfWeek={1}
        showOutsideDays
        navigationPosition="right"
        containerHeight={350}
        className="overflow-hidden"
        classNames={{
          ...defaultClassNames,
          today: "",
          day_cell: "p-1",
          day: "group hover:bg-brand-200 rounded-full aspect-square",
          selected: "bg-brand-400 hover:bg-brand-400",
          disabled: "opacity-50",
          range_fill: "bg-brand-100",
          day_label: "font-body text-xs",
          month_label: "font-body text-xs capitalize",
          year_label: "font-body text-xs capitalize",
          month_selector_label:
            "font-body text-sm capitalize font-bold hover:underline",
          year_selector_label: "font-body text-sm font-bold hover:underline",
          time_selector_label: "font-body text-xs",
          weekday_label: "font-body text-xs capitalize",
          time_label: "font-body text-xs",
          range_end_label: "text-white",
          range_middle_label: "font-body text-xs",
          range_start_label: "text-white",
          selected_label: "text-white",
          disabled_label: "font-body text-xs",
          outside_label: "font-body text-xs text-typography-200",
          today_label: "font-body text-xs",
          selected_month_label: "font-body",
          selected_year_label: "font-body text-sm",
          active_year_label: "font-body text-sm",
          button_prev: "hover:bg-primary-50",
          button_next: "hover:bg-primary-50",
        }}
        locale="es"
        timeZone="America/Santiago"
        components={{
          IconPrev: <Icon as={ChevronLeft} size="sm" />,
          IconNext: <Icon as={ChevronRight} size="sm" />,
        }}
      />
    </BasicModal>
  );
}

export function showDatePicker(options: ShowDatePickerOptions) {
  ModalProvider.show({
    children: <DatePickerContent {...options} hide={ModalProvider.hide} />,
    size: "sm",
  });
}
